var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4759_8699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7075 14.7075L19.7075 24.7075C19.5677 24.8475 19.3894 24.9429 19.1954 24.9815C19.0013 25.0202 18.8001 25.0004 18.6173 24.9246C18.4344 24.8489 18.2782 24.7206 18.1683 24.556C18.0585 24.3914 17.9999 24.1979 18 24V19.0287C10.8625 19.4337 5.9688 24.0625 4.59505 25.5287C4.37933 25.7591 4.09646 25.9156 3.78667 25.9759C3.47689 26.0362 3.15598 25.9972 2.86962 25.8645C2.58325 25.7319 2.34603 25.5123 2.1917 25.237C2.03737 24.9617 1.97381 24.6448 2.01005 24.3312C2.4738 20.2987 4.68255 16.42 8.23005 13.41C11.1763 10.91 14.7575 9.32374 18 9.04624V3.99999C17.9999 3.8021 18.0585 3.60861 18.1683 3.44401C18.2782 3.27942 18.4344 3.15112 18.6173 3.07537C18.8001 2.99962 19.0013 2.97981 19.1954 3.01846C19.3894 3.05712 19.5677 3.15248 19.7075 3.29249L29.7075 13.2925C29.8005 13.3854 29.8743 13.4957 29.9246 13.6171C29.9749 13.7385 30.0008 13.8686 30.0008 14C30.0008 14.1314 29.9749 14.2615 29.9246 14.3829C29.8743 14.5043 29.8005 14.6146 29.7075 14.7075Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4759_8699",
    x: -2,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4759_8699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4759_8699",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a75bfb28fcfb7469f87963aed5e2a10b.svg";
export { ForwardRef as ReactComponent };